import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Row, Col, Card } from "antd";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../branchTransferPendingSlice";
import {
  fetchBranchTransferPendingList,
  fetchBranches,
} from "../branchTransferPendingThunk";

const BranchTransferPendingFilters = () => {
  const dispatch = useDispatch();
  const { filters, branches } = useSelector(
    (state) => state.branchTransferPending
  );

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);

  const handleSubmit = () => {
    dispatch(fetchBranchTransferPendingList({ filters }));
  };

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={8} lg={6} xl={4} style={{ marginRight: 16 }}>
          <label>By Branch</label>
          <SearchListAutoComplete
            entityType="branch"
            optionsList={(branches || []).map((e) => ({
              sale_id: e.id,
              display_text: e.name,
            }))}
            // value={{
            //   value: filters.fromBranchId,
            //   label:
            //     lookups.branches?.message?.find(
            //       (b) => b.id === filters.fromBranchId
            //     )?.name || "Select Branch",
            // }}
            onSelect={(obj) => {
              if(!obj) {
                handleFilterChange("fromBranchId", null);
                return;
              } 
              handleFilterChange("fromBranchId", obj?.sale_id);
            }}            
            placeholder="By Branch"
            showAddNew={false}
          />
        </Col>

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Get Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default BranchTransferPendingFilters;
